export class FormatPhoneNumberHelper {
  static formatNumberPhone(phoneNumber, language) {
    const value = phoneNumber
      .toString()
      .trim()
      .replace(/^\+/, '');

    let country, city, number;
    switch (value.length) {
      case 10:
        country = 1;
        city = value.slice(0, 3);
        number = value.slice(3);
        break;
      case 11:
        country = value[0];
        city = value.slice(1, 4);
        number = value.slice(4);
        break;
      default:
        return 'badFormat';
    }
    if (country === 1) {
      country = '';
    }
    if (language === 'fr') {
      number = `${number.slice(0, 3)}-${number.slice(3)}`;
      return `${country} ${city} ${number}`.trim();
    } else if (language === 'en') {
      number = `-${number.slice(0, 3)}-${number.slice(3)}`;
      if (country === '1') {
        return `${country}-${city}${number}`.trim();
      } else {
        return `${city}${number}`.trim();
      }
    } else {
      return 'not language for format phone number';
    }
  }
}
